'use client'

import React from 'react'
import {Box} from '@chakra-ui/react'

/**
 * Veil Component
 * --------------
 * Used to apply a subtle overlay or blur effect (mostly for iOS Safari).
 * It remains invisible by default and only applies styling
 * when supported by the browser via @supports (-webkit-touch-callout: none).
 */
const Veil = () => {
    return (
        <Box
            className="veil"
            aria-hidden="true"
            sx={{
                display: 'none',
                '@supports (-webkit-touch-callout: none)': {
                    position: 'sticky',
                    top: 0,
                    zIndex: 10000,
                    display: 'block',
                    pointerEvents: 'none',

                    '& .veil-overlay': {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        opacity: 0,
                        backdropFilter: 'blur(1px)'
                    }
                }
            }}
        >
            <Box className="veil-overlay" />
        </Box>
    )
}

export default Veil
